
import { Component, Prop, Vue } from 'vue-property-decorator'
import InformationPanelMain from '@/components/organisms/manage/InformationPanelMain.vue'
import InformationPanelUser from '@/components/organisms/manage/InformationPanelUser.vue'
import { InformationPanelColorSet } from '@/const/manage/InformationPanelColorSet'

/**
 * 左側メニューのインフォメーションパネル(権限側)
 */
@Component({
  components: {
    InformationPanelMain,
    InformationPanelUser,
  },
})
export default class SidemenuInformationPanel extends Vue {
  /** インフォメーションパネルのカラーセット */
  @Prop()
  private informationPanelColorSet!: InformationPanelColorSet.ColorSet

  /** ユーザID */
  @Prop()
  private userId!: string

  /** ユーザ画像URL */
  @Prop()
  private imageUrl!: string

  /** ビューモードボタン押下時のイベント */
  @Prop()
  private eventClickToggleViewModeButton!: () => void

  /** 編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditButton!: () => void

  /** ログアウトボタン押下時のイベント */
  @Prop()
  private eventClickLogoutButton!: () => void

  /** パスワード変更ボタン押下時のイベント */
  @Prop()
  private eventClickChangePasswordButton!: () => void

  /** ユーザ情報の表示非表示 */
  private isShowUserPanel: boolean = false

  /**
   * インフォメーションパネルの色を設定する
   *
   * @returns css：カラー変数文字列
   */
  private get setStyle(): { [key: string]: string } {
    return {
      '--background-color': `var(${this.informationPanelColorSet.background})`,
    }
  }

  /**
   * ユーザ情報の表示切り替え
   */
  private toggleUserPanel(): void {
    if (!this.userId) {
      return
    }
    this.isShowUserPanel = !this.isShowUserPanel
  }
}
